export const excludeEmptyItem = <T = any>(arr?: T[] | null): T[] | undefined => arr?.filter((item) => item)

export const excludeUndefinedKey = (obj: Record<string, unknown>): Record<string, unknown> | null => {
  Object.keys(obj).forEach((key) => obj[key] === undefined && delete obj[key])
  if (Object.keys(obj).length === 0) return null
  return obj
}
